import React from 'react';
import { SpacingCustom } from '../../../layout/Spacing/SpacingCustom';
import { DownloadInfo } from '../Download/DownloadInfo';
import { ModalContentWrapper } from '../../../shared/Modal/ModalContentWrapper/ModalContentWrapper';
import { ScrollY } from '../../../layout/Scroll/ScrollY';
import { useTranslation } from 'react-i18next';
import { FlexCenter } from '../../../layout/FlexCenter/FlexCenter';

interface IConfigurationWindowProps {
    toolConfig: JSX.Element;
    func: () => void;
}

export const ConfigurationWindow: React.FC<IConfigurationWindowProps> = ({ toolConfig, func }) => {
    const { t, i18n } = useTranslation();

    return (
        <ModalContentWrapper hasIcon title={t('titles.configurationSettings')}>
            <ScrollY height={300}>
                <FlexCenter direction='h' position='end' gap={.5}>
                    {toolConfig}
                </FlexCenter>
            </ScrollY>

            <SpacingCustom marginTop={2}>
                <DownloadInfo />
            </SpacingCustom>
        </ModalContentWrapper>
    );
};
